export enum EHomeRoutes {
  ROOT = '/',
  HOME_LANDING = 'Home.Landing'
}
